(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video_gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("videoModal");
  const closeBtn = document.getElementById("videoModalClose");
  const thumbs = document.querySelectorAll(".video-thumb");

  const iframeWrapper = modal.querySelector(".video-iframe-wrapper");

  thumbs.forEach(thumb => {
    thumb.addEventListener("click", function () {
      const videoId = this.dataset.videoId;
      const iframe = document.createElement("iframe");
      iframe.id = "modalIframe";
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("loading", "lazy");
      iframe.setAttribute("title", "Popup Video Player");
      iframe.style.width = "90vw";
      iframe.style.maxWidth = "800px";
      iframe.style.height = "50vw";
      iframe.style.maxHeight = "450px";
      iframe.style.border = "none";

      // Clear any old iframe and add new one
      iframeWrapper.innerHTML = "";
      iframeWrapper.appendChild(iframe);

      modal.style.display = "flex";
    });
  });

  function closeModal() {
    modal.style.display = "none";
    iframeWrapper.innerHTML = ""; // ✅ This removes the iframe and stops playback
  }

  closeBtn.addEventListener("click", closeModal);
  window.addEventListener("click", function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeModal();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video_gallery_tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-icon-button");
  const videos = document.querySelectorAll(".video-tab-item");
  const modal = document.getElementById("videoModal");
  const iframeWrapper = modal.querySelector(".video-iframe-wrapper");
  const closeBtn = document.getElementById("videoModalClose");

  function showCategory(cat) {
    videos.forEach(video => {
      video.classList.remove("show");
      if (cat === "all" || video.classList.contains("tab-" + cat)) {
        video.classList.add("show");
      }
    });
    tabs.forEach(t => t.classList.remove("active"));
    document.querySelector(`.tab-icon-button[data-tab="${cat}"]`)?.classList.add("active");
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const category = this.getAttribute("data-tab");
      showCategory(category);
    });
  });

  document.querySelectorAll(".video-thumb").forEach(thumb => {
    thumb.addEventListener("click", function () {
      const videoId = this.dataset.videoId;
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("title", "YouTube Video");
      iframeWrapper.innerHTML = "";
      iframeWrapper.appendChild(iframe);
      modal.style.display = "flex";
    });
  });

  function closeModal() {
    modal.style.display = "none";
    iframeWrapper.innerHTML = "";
  }

  closeBtn.addEventListener("click", closeModal);
  window.addEventListener("click", function (e) {
    if (e.target === modal) closeModal();
  });
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });

  showCategory("all");
});

  } catch(e) { console.error(e); }
})();
})();
